import { AxiosInstance } from "../axios";

export const generateBlogSitemap = async () => {
  try {
    const res = await AxiosInstance.post("/api/blog/list", {
      blog_status: 1,
    });

    const blogs = res.data.blog || [];

    const urls = blogs.map((blog) => {
      const slug = blog.title
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-");

      const url = `https://bharatclouds.com/blog/${blog.id}/${slug}`;

      // 🔹 Format date to DD-MM-YYYY
      const date = new Date(blog.posted_date);
      const formattedDate = `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${date.getFullYear()}`;

      return `
<url>
<loc>${url}</loc>
<lastmod>${formattedDate}</lastmod>
<priority>0.8</priority>
</url>
`;
    });

    const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls.join("")}
</urlset>`;

  } catch (err) {
    console.error(err);
  }
};